//电站设置
import {getCrawlConfig,newestCrawlStats} from '@/api/maintain/config'

const state = {
	config: {name: '偏移量设置', key:'offset'},
    level: 1,   //默认第一级
    crawlConfig:null,
    CrawlStats:null,
    crawlShow:false
}
const getters = {
    config: state => state.config,
    level: state => state.level,
    crawlConfig:state=>state.crawlConfig,
    CrawlStats:state=>state.CrawlStats,
    crawlShow:state=>state.crawlShow
}

const mutations = {
    SET_CONFIG: (state, config) => {
        state.config = config
	},
	SET_LEVEL: (state, level) => {
		state.level = level
    },
    GET_CRAWL:(state,item)=>{
        state.crawlConfig=item
    },
    GET_STATS:(state,item)=>{
        state.CrawlStats=item
    },
    GET_CRAWLSHOW:(state,item)=>{
        state.crawlShow=item
    }
}
const actions ={
     //获取爬取数据配置
    GETCRAWLCONFIG({ commit }, id) {
        return new Promise((resolve, reject) => {
            getCrawlConfig(id).then(response => {
                commit('GET_CRAWL', response)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    //最新采集数据
    GETCRAWSTATS({commit},id){
        return new Promise((resolve, reject) => {
            newestCrawlStats(id).then(response => {
                commit('GET_STATS', response)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}






// WEBPACK FOOTER //
// ./src/store/modules/stationConfig.js